import { Modal } from 'bootstrap';

const initShareLinkModal = () => {
  const modalEl = document.getElementById('shareLinkModal');
  if (!modalEl) return;

  const modal = Modal.getOrCreateInstance(modalEl);
  const inputEl = modalEl.querySelector<HTMLInputElement>('[data-share-input]');
  const copiedEl = modalEl.querySelector<HTMLElement>('[data-share-copied]');
  const copyBtn = modalEl.querySelector<HTMLElement>('[data-share-copy]');

  if (!inputEl || !copyBtn) return;

  const resetCopied = () => {
    if (copiedEl) copiedEl.style.display = 'none';
  };

  modalEl.addEventListener('hidden.bs.modal', resetCopied);

  copyBtn.addEventListener('click', async () => {
    const value = inputEl.value;
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      if (copiedEl) copiedEl.style.display = 'inline';
    } catch (error) {
      try {
        inputEl.select();
        document.execCommand('copy');
        if (copiedEl) copiedEl.style.display = 'inline';
      } catch (err) {
        console.error('Failed to copy link', err);
      }
    }
  });

  if (inputEl) {
    inputEl.value = window.location.href;
  }

  const buttons = document.querySelectorAll<HTMLElement>('[data-share-link]');
  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const url = button.getAttribute('data-share-url') || window.location.href;
      inputEl.value = url;
      resetCopied();
      modal.show();
    });
  });
};

document.addEventListener('turbo:load', initShareLinkModal);
document.addEventListener('DOMContentLoaded', initShareLinkModal);
